<template>
  <bm-text
    v-bind="$attrs"
    :value="value"
    @update:value="emit('update:value', $event)"
  >
    <template v-if="value" #readOnly>
      <v-container class="wrap fluid px-1">
        <v-row
          v-for="email in emailAddressList"
          :key="email"
          dense
          class="py-1"
        >
          <v-col>
            <a :href="emailHref(email)">{{ email }}</a>
          </v-col>
          <v-col cols="auto">
            <bm-btn icon button-type="ghost" @click="copyToClipboard(email)">
              <bm-icon icon="Assignment" small />
            </bm-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </bm-text>
</template>

<script setup lang="ts">
import BmBtn from "@/components/controls/input/BmBtn.vue";
import { computed } from "vue";

interface BmEmailProps {
  value?: string;
}

interface BmEmailEvents {
  (event: "update:value", value: string): void;
}

const props = withDefaults(defineProps<BmEmailProps>(), {
  value: "",
});

const emit = defineEmits<BmEmailEvents>();

const emailHref = (email: string) => {
  return `mailto:${email}`;
};

const emailAddressList = computed(() => {
  return props.value.split(";");
});

const copyToClipboard = (email: string) => {
  navigator.clipboard.writeText(email);
};
</script>

<style lang="sass" scoped>
.wrap
  word-break: break-word
  max-height: 20ch
  overflow-y: auto
</style>
